export function isCookieEnabled() {
	if (navigator.cookieEnabled) {
		return true;
	}

	// set and read cookie
	document.cookie = "cookietest=1";
	let ret = document.cookie.indexOf("cookietest=") != -1;

	// delete cookie
	document.cookie = "cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT";

	return ret;
}

/**
 * Set a cookie
 *
 * @param {String} name
 * @param {*} value
 * @param {*} days
 */
export function setCookie(name, value, days) {
	let expires = "";
	if (days) {
		let date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

/**
 * Get a cookie
 *
 * @param {String} name
 */
export function getCookie(name) {
	let nameEQ = name + "=";
	let ca = document.cookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1, c.length);
		}
		if (c.indexOf(nameEQ) == 0) {
			return c.substring(nameEQ.length, c.length);
		}
	}
	return null;
}
